import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MembershipLevelUpdateDto, UserInfoDto, UserProfileDto } from 'services/data-contracts';
import { useStoreWrapper } from 'stores/StoreHelper';
import { InputField, Row, Select } from 'saladsoft-primitive';
import ModifyButtons from 'components/layouts/ModifyButtons';
import ServiceHelper from 'stores/ServiceHelper';
import { toast } from 'react-toastify';

const UserDetail = ({ user, onSave }: { user: UserInfoDto; onSave?: () => void }) => {
  const { uiStore, userFilterStore } = useStoreWrapper();

  const [phoneNumber, setPhoneNumber] = useState(user.profile?.phoneNumber || '');
  const [countryCode, setCountryCode] = useState(user.profile?.countryCode || '');
  const [birthday, setBirthday] = useState(user.profile?.birthday || '');
  const [membershipLevel, setMembershipLevel] = useState(user.membershipLevel || '');
  const [isAdmin, setIsAdmin] = useState(user.roleType === 'ADMIN' || false);

  // 회원등급 수정
  const saveMembershipLevel = async () => {
    if (!user.id) return;

    const membershipData: MembershipLevelUpdateDto = {
      membershipLevel: membershipLevel as MembershipLevelUpdateDto['membershipLevel'],
    };

    const res = await ServiceHelper.adminUserService?.setMembershipLevel(user.id, membershipData);

    if (res?.data) {
      setMembershipLevel(membershipLevel);

      toast.success('회원등급 수정 완료');

      onSave?.();
      uiStore?.modal.close();
    } else {
      toast.error('회원등급 수정 실패');
    }
  };

  useEffect(() => {
    if (user) {
      setMembershipLevel(user.membershipLevel || '');
    }
  }, [user]);

  // 회원정보 저장
  // const saveUserInfo = async () => {
  //   if (!user.id) return;

  //   try {
  //     const profileData: UserProfileDto = {
  //       ...user.profile,
  //       countryCode: countryCode,
  //       phoneNumber: phoneNumber,
  //       birthday: birthday,
  //     };

  //     const response = await ServiceHelper.adminMemberService?.saveMyProfile1(user.id, profileData);

  //     if (response?.data) {
  //       toast.success('회원정보 수정 완료');
  //       onSave?.();
  //       uiStore?.modal.close();
  //     } else {
  //       toast.error('회원정보 수정 실패');
  //     }
  //   } catch (error) {
  //     console.error('회원정보 저장 실패', error);
  //     toast.error('회원정보 저장 실패');
  //   }
  // };

  // 취소 시 원래 값으로 복원
  const handleCancel = () => {
    setMembershipLevel(user.membershipLevel || '');
    // setPhoneNumber(user.profile?.phoneNumber || '');
    // setCountryCode(user.profile?.countryCode || '');
    // setBirthday(user.profile?.birthday || '');
    // setIsAdmin(user.isAdmin || false);
  };

  return (
    <>
      <ModalContent>
        <Row gap={20} alignItems="flex-start" justifyContent="space-between">
          <InfoSection>
            <SectionTitle>고객정보</SectionTitle>
            <InfoGrid>
              <InfoLabel>이름</InfoLabel>
              <InfoValue>
                {user.profile?.lastName} {user.profile?.firstName}
              </InfoValue>

              <InfoLabel>이메일</InfoLabel>
              <InfoValue
                style={{ cursor: 'pointer', color: '#0078d4' }}
                onClick={() => {
                  window.open(`mailto:${user.username}`, '_blank');
                }}
              >
                {user.username}
              </InfoValue>

              <InfoLabel>전화번호</InfoLabel>
              <InfoValue>{`${user.profile?.countryCode} ${user.profile?.phoneNumber}`}</InfoValue>
              {/* <InfoValue>
                <Row gap={6}>
                  <StyledInputField
                    type="text"
                    value={countryCode}
                    onChange={(value) => setCountryCode(value)}
                    // disabled={true}
                  />
                  <StyledInputField
                    type="text"
                    value={phoneNumber}
                    onChange={(value) => setPhoneNumber(value)}
                  />
                </Row>
              </InfoValue> */}

              <InfoLabel>회원등급</InfoLabel>
              <SelectWrapper>
                <Select
                  key={membershipLevel}
                  items={[
                    { key: 'CLASSIC', value: 'CLASSIC' },
                    { key: 'SILVER', value: 'SILVER' },
                    { key: 'GOLD', value: 'GOLD' },
                    { key: 'PLATINUM', value: 'PLATINUM' },
                  ]}
                  defaultKey={membershipLevel}
                  onChange={(value) => setMembershipLevel(value.key)}
                  containerStyle={{
                    fontSize: '14px',
                    height: 36,
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                  }}
                  useRound={false}
                  className="custom-select"
                />
              </SelectWrapper>

              <InfoLabel>생년월일</InfoLabel>
              <InfoValue>{user.profile?.birthday ? user.profile?.birthday : '-'}</InfoValue>
              {/* <StyledInputField
                type="text"
                value={birthday}
                onChange={(value) => setBirthday(formatBirthday(value))}
              />
              <InfoLabel>보유 포인트</InfoLabel>
              <InfoValue>{formatNumberWithCommas(user.point || 0)} P</InfoValue> */}

              {/* <InfoLabel>관리자</InfoLabel>
              <InfoValue>
                <RadioGroup>
                  <RadioOption>
                    <HiddenRadio
                      disabled
                      type="radio"
                      id="admin-yes"
                      name="isAdmin"
                      checked={isAdmin === true}
                      onChange={() => setIsAdmin(true)}
                    />
                    <StyledLabel htmlFor="admin-yes" selected={isAdmin === true}>
                      Y
                    </StyledLabel>
                  </RadioOption>{' '}
                  <RadioOption>
                    <HiddenRadio
                      disabled
                      type="radio"
                      id="admin-no"
                      name="isAdmin"
                      checked={isAdmin === false}
                      onChange={() => setIsAdmin(false)}
                    />
                    <StyledLabel htmlFor="admin-no" selected={isAdmin === false}>
                      N
                    </StyledLabel>
                  </RadioOption>
                </RadioGroup>
              </InfoValue> */}
            </InfoGrid>
          </InfoSection>
        </Row>
      </ModalContent>

      <ButtonRow>
        <ModifyButtons
          type="update"
          showDelete={false}
          onCancel={() => {
            handleCancel();
            uiStore?.modal.close();
          }}
          onSave={() => {
            // saveUserInfo();
            saveMembershipLevel();
          }}
          onDelete={() => { }}
        />
      </ButtonRow>
    </>
  );
};

const ModalContent = styled.div`
  padding: 32px;
  max-height: 70vh;
  border-radius: 8px 8px 0 0;
`;

const InfoSection = styled.div`
  margin-bottom: 24px;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eaeaea;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 16px;
  align-items: center;
`;

const InfoLabel = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  min-width: 120px;
`;

const InfoValue = styled.div`
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
`;

const StyledInputField = styled(InputField)`
  width: 100%;
  font-size: 14px;
  color: #333;

  .MuiOutlinedInput-root {
    height: 36px;
    font-size: 14px;
  }

  .MuiOutlinedInput-input {
    padding: 8px 12px;
    height: 20px;
    font-size: 14px;
  }

  .MuiInputLabel-root {
    font-size: 14px;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #0078d4;
    border-width: 1px;
  }

  &:focus {
    border-color: #0078d4;
    outline: none;
  }
`;

const SelectWrapper = styled.div`
  .custom-select .sc-e0zmre,
  .custom-select button[class*='sc-'] {
    background: none !important;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 32px;
  background-color: white;
`;

// 라디오 버튼 (관리자 여부 선택)
const RadioGroup = styled.div`
  display: flex;
  gap: 5px;
  border-radius: 4px;
`;

const RadioOption = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  input[type='radio'] {
    margin: 0;
    /* cursor: pointer; */
  }

  label {
    font-size: 14px;
    /* cursor: pointer; */
  }
`;

const HiddenRadio = styled.input`
  display: none;
`;

const StyledLabel = styled.label<{ selected: boolean }>`
  display: inline-block;
  padding: 6px 24px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: not-allowed;
  font-size: 14px;
  font-weight: 500;
  color: ${({ selected }) => (selected ? '#0078d4' : '#666')};
  min-width: 40px;
  text-align: center;
  transition: all 0.2s;

  color: ${(props) => (props.selected ? '#fff' : '#333')};
  background-color: ${(props) => (props.selected ? '#d32f2f' : '#f9f9f9')};
  border-color: ${(props) => (props.selected ? '#d32f2f' : '#ccc')};
`;

export default UserDetail;
